import { render, staticRenderFns } from "./CrearAlertaModal.vue?vue&type=template&id=bf9f51e4&"
import script from "./CrearAlertaModal.vue?vue&type=script&lang=ts&"
export * from "./CrearAlertaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bf9f51e4', component.options)
    } else {
      api.reload('bf9f51e4', component.options)
    }
    module.hot.accept("./CrearAlertaModal.vue?vue&type=template&id=bf9f51e4&", function () {
      api.rerender('bf9f51e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Alertas/CrearAlertaModal.vue"
export default component.exports